module.exports = __webpack_public_path__ + "img/image02_sp.0079a83a.jpg";